import { render, staticRenderFns } from "./SalesVolumeChart.vue?vue&type=template&id=31e97824&scoped=true&"
import script from "./SalesVolumeChart.vue?vue&type=script&lang=js&"
export * from "./SalesVolumeChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesVolumeChart.vue?vue&type=style&index=0&id=31e97824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e97824",
  null
  
)

export default component.exports